import { useState } from "react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "web-design-system";
import { MoreVerticalIcon } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { Client, SubmittedOrder } from "creso-core/types";
import { CancelSubmittedOrderDialog } from "./cancel-submitted-order-dialog";

function canCancelSubmittedOrder(order: SubmittedOrder) {
  return order.type === "PURCHASE" && order.order_status === "Payment pending";
}

export function OrderRowActions({
  order,
  client,
}: {
  order: SubmittedOrder;
  client: Client;
}) {
  const navigate = useNavigate();
  const [showCancelDialog, setShowCancelDialog] = useState(false);

  const isPaymentPending = order.order_status === "Payment pending";
  const showCancel = canCancelSubmittedOrder(order);
  const showNeftRtgs = isPaymentPending && order.product_type !== "GIFT";

  return (
    <>
      <CancelSubmittedOrderDialog
        client={client}
        order={order}
        open={showCancelDialog}
        toggle={setShowCancelDialog}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <MoreVerticalIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={() =>
              navigate({
                to: ".",
                search: (prev) => ({
                  ...prev,
                  modal: "order-detail",
                  client_id: client.id,
                  order_id: order.id.toString(),
                }),
              })
            }
          >
            View
          </DropdownMenuItem>
          {showNeftRtgs && (
            <DropdownMenuItem
              onClick={() =>
                navigate({
                  to: ".",
                  search: (prev) => ({
                    ...prev,
                    modal: "neft-rtgs",
                    client_id: client.id,
                    order_id: order.id.toString(),
                  }),
                })
              }
            >
              NEFT/RTGS
            </DropdownMenuItem>
          )}
          {showCancel && (
            <DropdownMenuItem
              className="text-destructive hover:text-destructive focus:bg-destructive/10 focus:text-destructive data-[highlighted]:bg-destructive/10 data-[highlighted]:text-destructive"
              onClick={() => setShowCancelDialog(true)}
            >
              Cancel
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
